module.exports = __webpack_public_path__ + "img/img-bottom.486af674.jpg";